/*
 BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.
* This computer code is proprietary and highly confidential to Baker Hughes Company
* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,
* or reproduced without prior written consent, and must be returned on demand.
*/

import { useEntity } from '@backstage/plugin-catalog-react';
import { isComponentType, isKind } from '@backstage/plugin-catalog';
import { useEffect } from 'react';

export const EntityHeaderStyles = () => {
  const { entity } = useEntity();
  const shouldHideElements =
    isComponentType('service')(entity) ||
    isComponentType('api-interface')(entity) ||
    isKind('system')(entity) ||
    isKind('domain')(entity) ||
    isKind('api')(entity) ||
    isKind('location')(entity);

  useEffect(() => {
    if (shouldHideElements) {
      const removeElements = () => {
        // Target and remove owner information
        const headerGrids = document.querySelectorAll('header [class*="MuiGrid-container"] [class*="MuiGrid-item"]:first-child');
        headerGrids.forEach(gridItem => {
          const ownerText = gridItem.textContent?.toLowerCase();
          if (ownerText && ownerText.includes('owner')) {
            gridItem.remove();
          }
        });
        
        // Remove favorite button from header
        const favoriteButtons = document.querySelectorAll(
          'header button[aria-label*="favorites"]',
        );
        favoriteButtons.forEach(button => {
          if (button.closest('header')) {
            button.remove();
          }
        });

        // --- START: MODIFIED CODE ---
        // Remove the entire three-dot menu button
        const menuButton = document.querySelector('[data-testid="menu-button"]');
        if (menuButton) {
          menuButton.remove();
        }
        // --- END: MODIFIED CODE ---
      };

      // Run immediately
      removeElements();
      
      // Run after short delays (in case elements load later)
      setTimeout(removeElements, 100);
      setTimeout(removeElements, 500);
      
      // Watch for new elements being added
      const observer = new MutationObserver(() => {
        removeElements();
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Cleanup observer on unmount
      return () => observer.disconnect();
    }
    return undefined;
  }, [shouldHideElements]);

  return null;
};